"use client";

import { useEditMode } from "@/contexts/EditModeContext";
import { cn } from "@/lib/shared/utils";
import { type ReactNode } from "react";

export default function HeaderEditWrapper({ children }: { children: ReactNode }) {
  const { isEditing, isSectionHidden, openSectionEditor } = useEditMode();
  const hidden = isSectionHidden("header");

  if (!isEditing) {
    if (hidden) return null;
    return <>{children}</>;
  }

  return (
    <>
      <div className="pointer-events-none sticky top-0 z-[51] flex items-start justify-center">
        <div className="pointer-events-auto">
          <button
            onClick={() => openSectionEditor("header")}
            className="bg-foreground text-background hover:bg-foreground/80 cursor-pointer px-2 py-0.5 font-mono text-[9px] font-bold tracking-wider uppercase transition-colors"
            title="Edit header"
          >
            header
          </button>
        </div>
      </div>
      <div className={cn("contents", hidden && "[&>[data-header]]:opacity-30")}>{children}</div>
    </>
  );
}
